import apiClient from '../utils/apiClient';

// Fetch employees for timesheet dropdown
export async function getTimesheetEmployees(params = {}) {
    const response = await apiClient.get('/api/timesheets/employees', { params });
    return response.data.employees;
}

export async function updateTimesheetEmployeeVisibility(employeeId, hidden) {
    const response = await apiClient.put(`/api/timesheets/employees/${employeeId}/visibility`, { hidden });
    return response.data;
}

export async function getTimesheetClientCompanies() {
    const response = await apiClient.get('/api/timesheets/client-companies');
    return response.data.clientCompanies;
}

// Fetch all timesheets for a specific user
export async function fetchTimesheets(filters = {}) {
    // Build query params from filters object
    const params = {};
    if (filters.userId) params.userId = filters.userId;
    if (filters.employee_id) params.employee_id = filters.employee_id;
    if (filters.project_id) params.project_id = filters.project_id;
    if (filters.start_date) params.start_date = filters.start_date;
    if (filters.end_date) params.end_date = filters.end_date;

    const response = await apiClient.get('/api/timesheets', { params });
    return response.data;
}

// Create a new timesheet entry
export async function createTimesheet(timesheetData) {
    const response = await apiClient.post('/api/timesheets', timesheetData);
    return response.data;
}

// Update an existing timesheet entry
export async function updateTimesheet(timesheetId, timesheetData) {
    const response = await apiClient.put(`/api/timesheets/${timesheetId}`, timesheetData);
    return response.data;
}

// Delete a timesheet entry
export async function deleteTimesheet(timesheetId) {
    const response = await apiClient.delete(`/api/timesheets/${timesheetId}`);
    return response.data;
}

// Export timesheets to CSV
export async function exportTimesheets(params = {}) {
    const response = await apiClient.get('/api/timesheets/export', {
        params,
        responseType: 'blob' // Important for file downloads
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `timesheets_export_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return response.data;
}